import { render, staticRenderFns } from "./SectionAbout.vue?vue&type=template&id=52cad90e&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"
import style0 from "./SectionAbout.vue?vue&type=style&index=0&id=52cad90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cad90e",
  null
  
)

export default component.exports